"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetDeliveryMethods = void 0;
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _shoppingContext = require("@ori/shopping-context");
var _swrConfig = require("../constants/swrConfig");
var _logger = require("../logger");
var _utils = require("../utils");
const hookName = 'useGetDeliveryMethods';
const useGetDeliveryMethods = ()=>{
    const { shoppingContext: { sessionId } = {} } = (0, _shoppingContext.useShoppingContext)();
    const { tenant } = (0, _environment.useEnvironment)();
    const { language } = (0, _i18n.useLanguage)();
    const headers = (0, _utils.getHeaders)({
        currentLanguage: language,
        tenant
    });
    const isActive = Boolean(sessionId);
    const { data, isValidating: isLoadingDeliveryMethods } = (0, _globalApiClientReact.useGetShoppingSessionDeliveryMethods)(sessionId !== null && sessionId !== void 0 ? sessionId : '', headers, {
        swr: {
            ..._swrConfig.errorHandlingSwrOptions,
            enabled: isActive,
            onSuccess: (loadedData)=>{
                (0, _logger.logDebug)("".concat(hookName, " hook finished successfully."), {
                    loadedData,
                    sessionId
                });
            }
        }
    });
    return {
        deliveryMethods: data === null || data === void 0 ? void 0 : data.collection,
        isLoadingDeliveryMethods
    };
};
exports.useGetDeliveryMethods = useGetDeliveryMethods;
